import { render, staticRenderFns } from "./IconDialogSummaryAlt.vue?vue&type=template&id=50735c54"
import script from "./IconDialogSummaryAlt.vue?vue&type=script&lang=js"
export * from "./IconDialogSummaryAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports